import {AlertIcon} from '@primer/octicons-react'
import {PageLayout, Spinner} from '@primer/react'
import {Blankslate} from '@primer/react/experimental'
import type {FC, ReactNode} from 'react'

interface FindingsErrorProps {
  error?: string | null
}

export const FindingsError: FC<FindingsErrorProps> = ({error}) => (
  <FindingsLifecycleContainer>
    <Blankslate className="border rounded-3" role="alert">
      <Blankslate.Visual>
        <AlertIcon size="medium" className="color-fg-danger" />
      </Blankslate.Visual>
      <Blankslate.Heading as="h2">Failed to load findings</Blankslate.Heading>
      {error && <Blankslate.Description>{error}</Blankslate.Description>}
    </Blankslate>
  </FindingsLifecycleContainer>
)

export const FindingsLoadingState: FC = () => (
  <FindingsLifecycleContainer>
    <div className="d-flex flex-justify-center tmp-p-6" role="status" aria-label="Loading findings">
      <Spinner size="large" delay="short" />
    </div>
  </FindingsLifecycleContainer>
)

export const FindingsNotFoundState: FC = () => (
  <FindingsLifecycleContainer>
    <Blankslate className="border rounded-3">
      <Blankslate.Heading as="h2">No findings available</Blankslate.Heading>
      <Blankslate.Description>
        Copilot has not detected any findings for this pull request. This could be because the analysis has not
        completed yet, or because there are no findings to report.
      </Blankslate.Description>
    </Blankslate>
  </FindingsLifecycleContainer>
)

export const FindingsProcessingState: FC = () => (
  <FindingsLifecycleContainer>
    <Blankslate className="border rounded-3">
      <Blankslate.Heading as="h2">Processing findings</Blankslate.Heading>
      <Blankslate.Description>Findings are being processed. This page will update automatically</Blankslate.Description>
    </Blankslate>
  </FindingsLifecycleContainer>
)

export const FindingsNoFindingsState: FC = () => (
  <FindingsLifecycleContainer>
    <Blankslate className="border rounded-3">
      <Blankslate.Heading as="h2">No findings</Blankslate.Heading>
      <Blankslate.Description>There are no findings for this pull request</Blankslate.Description>
    </Blankslate>
  </FindingsLifecycleContainer>
)

const FindingsLifecycleContainer: FC<{children: ReactNode}> = ({children}) => (
  <PageLayout.Content as="div" padding="none">
    {children}
  </PageLayout.Content>
)
